import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'pm-icon',
  imports: [CommonModule],
  templateUrl: './pm-icon.component.html',
  styleUrl: './pm-icon.component.scss',
})
export class PmIconComponent {
  @Input({ required: true }) icon!: string;
  @Input() fill = false;
  @Input() type: 'DEFAULT' | 'LIGHT' = 'DEFAULT';
  @Input() disabled = false;
  @Input() color: string | null = null;
  @Input() weight: string | null = null;
}
